import React from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import {
  getTagStyle,
  getPointPlanFeatures,
} from "utility/options/pointsPlans";

const badgeStyle = {
  popular: "bg-SKF-Blue-001 text-white",
  combo: "bg-SKF-Green-001 text-black",
  value: "bg-SKF-Orange-001 text-black",
};

const PointsPlanCard = ({ plan, onBuy, loading }) => {
  const { name, tag, amount, bonusAmount, totalAmount, price, isDefault } = plan;
  const features = getPointPlanFeatures(plan);
  const pricePerPoint =
    totalAmount > 0 ? Number((price / totalAmount).toFixed(2)) : null;
  const featured = isDefault;

  // 卡片不提供「選取」狀態，只有 hover 回饋；實際動作由「立即購買」觸發
  return (
    <div
      className={`relative flex flex-col text-left rounded-2xl border border-solid px-6 pt-7 pb-6 transition duration-200 hover:-translate-y-0.5 ${
        featured
          ? "bg-gradient-to-br from-[#1E2A3A] to-[#141E2E]"
          : "bg-SKF-G-005"
      } ${
        featured
          ? "border-[rgba(76,155,248,0.35)] hover:border-[rgba(76,155,248,0.6)]"
          : "border-white/10 hover:border-white/20"
      }`}
    >
      {/* 標籤 */}
      {tag && (
        <span
          className={`absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full px-3 py-1 text-xs font-semibold tracking-wide ${
            badgeStyle[getTagStyle(tag)]
          }`}
        >
          {tag}
        </span>
      )}

      <p className="mb-4 text-xs font-medium uppercase tracking-[2px] text-SKF-G-002">
        {name}
      </p>

      <p className="mb-1 text-4xl font-bold leading-none tracking-tight text-white">
        {amount.toLocaleString()}
        <span className="ml-1 text-base font-normal text-SKF-G-002">點</span>
      </p>

      <p className="mb-5 min-h-[20px] text-[13px] font-medium text-SKF-Green-001">
        {bonusAmount > 0 ? `+ 加贈 ${bonusAmount.toLocaleString()} 點` : " "}
      </p>

      <div className="mb-5 h-px bg-white/10" />

      <p className="mb-1 text-xs text-SKF-G-002">方案售價</p>
      <p className="mb-1 text-[28px] font-bold leading-tight text-white">
        NT$ {price.toLocaleString()}
      </p>
      <p className="mb-6 text-xs text-SKF-G-002">
        {bonusAmount > 0 || pricePerPoint === null ? (
          `共 ${totalAmount.toLocaleString()} 點可用`
        ) : (
          <>
            每點{" "}
            <strong className="text-white/70">
              NT$ {pricePerPoint.toLocaleString()}
            </strong>
          </>
        )}
      </p>

      <button
        type="button"
        disabled={loading}
        onClick={() => onBuy(plan)}
        className={`mb-5 w-full cursor-pointer rounded-[10px] border border-solid py-2.5 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-60 ${
          featured
            ? "border-SKF-Blue-001 bg-SKF-Blue-001 text-white hover:bg-[#3B8DE0]"
            : "border-white/20 bg-transparent text-white hover:bg-white/10"
        }`}
      >
        立即購買
      </button>

      <ul className="m-0 flex list-none flex-col gap-2.5 p-0">
        {features.map((feature) => (
          <li
            key={feature}
            className="flex items-start gap-2 text-[13px] leading-snug text-white/65"
          >
            <CheckIcon className="mt-px w-4 shrink-0 text-SKF-Green-001" />
            {feature}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PointsPlanCard;
